// extracted by css-extract-rspack-plugin
export default {"warningText":"XEjI_TzwaaIMg4MW"};